<template>
  <div class="tracking__part tracking-timelines">
    <div class="timeline actived">
      <CartBuyIcon />
      <b class="time"> {{ getFormatedDate(tracking.created_at) }}</b>
      <span> Order Placed</span>
    </div>
    <ProgressBar
      class="progress"
      size="sm"
      :is-striped="trackingStageStatus < TRACKING_NUMBER_DELIVERED"
      :value="trackingStageStatus >= TRACKING_NUMBER_IN_TRANSIT ? 100 : 70"
      :is-animated="true"
    ></ProgressBar>
    <div
      class="timeline"
      :class="
        trackingStageStatus >= TRACKING_NUMBER_IN_TRANSIT ? 'actived' : ''
      "
    >
      <PlaneIcon />
      <b class="time"> {{ getFormatedDate(tracking.shipped_at) }}</b>
      <span> Order Shipped</span>
    </div>
    <ProgressBar
      class="progress"
      :class="trackingStageStatus < TRACKING_NUMBER_IN_TRANSIT ? 'hide' : ''"
      size="sm"
      :is-striped="trackingStageStatus < TRACKING_NUMBER_DELIVERED"
      :value="trackingStageStatus >= TRACKING_NUMBER_DELIVERED ? 100 : 70"
      :is-animated="true"
    ></ProgressBar>
    <div
      class="timeline"
      :class="trackingStageStatus >= TRACKING_NUMBER_DELIVERED ? 'actived' : ''"
    >
      <CheckCircleIcon />
      <b class="time"> {{ getFormatedDate(tracking.delivered_at) }}</b>
      <span> Delivered</span>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import ProgressBar from '@/ui-kits/ProgressBar.vue'
import PlaneIcon from '@/assets/images/icons/plane.svg'
import CartBuyIcon from '@/assets/images/icons/cart-buy.svg'
import CheckCircleIcon from '@/assets/images/icons/check-circle.svg'
import { dateFormatShortMonthAndDay } from '@/utils/date'
import { Tracking } from '@/types/tracking'

const props = withDefaults(
  defineProps<{
    tracking: Tracking
  }>(),
  {}
)

const trackingStageStatus = computed(() =>
  trackingStage(props.tracking.tracking_status)
)

const TRACKING_NUMBER_IN_PRODUCTION = 1
const TRACKING_NUMBER_IN_TRANSIT = 2
const TRACKING_NUMBER_DELIVERED = 3

function getFormatedDate(dateString: string, defaultString = 'TBD') {
  if (!dateString) return defaultString
  const date = new Date(dateString)
  if (isNaN(date)) return defaultString
  return dateFormatShortMonthAndDay(date)
}

function trackingStage(status: string) {
  const TRACKING_STATUS_IN_TRANSIT = 'InTransit'
  const TRACKING_STATUS_DELIVERED = 'Delivered'
  if (status === TRACKING_STATUS_DELIVERED) return TRACKING_NUMBER_DELIVERED
  if (status === TRACKING_STATUS_IN_TRANSIT) return TRACKING_NUMBER_IN_TRANSIT
  return TRACKING_NUMBER_IN_PRODUCTION
}
</script>

<style lang="scss">
.tracking-timelines {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .timeline {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-width: fit-content;
    gap: 0.5em;
    font-size: 0.85rem;
    color: var(--text-color-tertiary);
  }
  .progress {
    --progress-bar-border-radius: 0;
    --progress-bar-sm-height: 0.5rem;
    @include media-sm-up {
      margin: 0 2em;
      --progress-bar-sm-height: 0.75rem;
    }
    margin: 0 0.5em;
  }
  .actived {
    color: var(--text-color-primary);
    svg {
      opacity: 1;
    }
  }
  .hide {
    opacity: 0;
  }
  svg {
    opacity: 0.3;
    width: 20px;
  }
}
</style>
